<template lang="html">
  <div class="slds-grid slds-wrap">
    <gnetTable
      v-bind:wrapheader="true"
      v-bind:cols="cols"
      v-bind:records="rows"
      v-on:xfilter="filterCol($event)"
      v-on:xrow="filterRow($event)"
      v-on:click="gotoRecord($event)">
    </gnetTable>
    <spinner v-bind:busy="busy"></spinner>
  </div>
</template>

<script>
import apiclient from '@/apiclient.js'
import gnetTable from '../components/table.vue'
import spinner from '../components/spinner.vue'

export default {
  name: 'fatture',
  components: {
    gnetTable,
    spinner
  },
  props: {
      campagne: Array, // filtro campagne booleano
  },
  data() {
    return {
      tipovalore: "quantità",
      tipodato: "ordinato",

      campagna:0,
      busy: false,

      records:[],
      cols:[],
      rows:[],

      filteredCol: -1,
      filteredRow: -1,

      fieldsstring: '',
      filterPanel: {
        show: false,
        value:'',
        name:'',
        index:0,
        filterCol: {}
      }
    }
  },
  computed: {
    actualdealer: function() {
      if (this.$store.state.multizona) 
        return this.$store.getters.zona;
      else
        return '';
    },
  },
  watch: {
    actualdealer: function() {
      this.getRecords();
    },
  },
  created: function() {
  },
  mounted: function() {
    if (!this.campagna) this.campagna=this.$store.state.campagne[0];
    this.getRecords();
  },
  methods: {    
    gotoRecord: function(record) {
      console.log('gotoRecord'+record.Id);
      this.$router.push({ name:'CustomerForm', params: { id: record.Id, record: record } });
    },
    changeDato: function() {
      console.log(this.tipodato);
      this.filteredCol=-1;
      this.getRecords();
    },
    changeValore: function() {
      console.log(this.tipovalore);
      this.getCols();      
    },
    changeCampagna: function(index) {
      console.log('changeCampagna');
      console.log(index);
      this.campagna=this.$store.state.campagne[index];
      this.getRecords();
    },
    filterCol: function(index) {
      console.log('filter:'+index);
      if (this.filteredCol<0) {
        this.filteredCol=index;
      } else {
        this.filteredCol=-1;
      }
      this.getCols();      
    },
    filterRow: function(index) {
      console.log('filter:'+index);
      if (this.filteredRow<0) {
        this.filteredRow=index;
      } else {
        this.filteredRow=-1;
      }
      this.getCols();      
    },
    getCols: function() {
      this.cols.splice(0,this.cols.length);
      this.rows.splice(0,this.rows.length);

      console.log('inizio getcol');
      console.log(new Date());

      var ord=0;
      this.cols.push( { order: ord++, value:'', label:'PV', name:'COUNTY', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Città', name:'CITY', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Cap', name:'ZIPCODE', type:'string' } );
      // this.cols.push( { order: ord++, value:'', label:'CC', name:'custaccount', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Cliente', name:'codice_nome', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Camp.', name:'FCP_COPYCMSCAMPAIGNID', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Linea', name:'linea', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Codice', name:'itemid', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Descrizione', name:'descrizione_articolo', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Totale', name:'Importo', type:'currency' } );
      this.cols.push( { order: ord++, value:'', label:'Vend.', name:'Quantita_Venduta', type:'decimal' } );
      this.cols.push( { order: ord++, value:'', label:'Om.', name:'Quantita_Omaggio', type:'decimal' } );
      this.cols.push( { order: ord++, value:'', label:'Rese', name:'Quantita_Rese', type:'decimal' } );
      this.cols.push( { order: ord++, value:'', label:'Tot', name:'Quantita_Totale', type:'decimal' } );
      this.cols.push( { order: ord++, value:'', label:'Sc%', name:'Sconto', type:'decimal' } );

      // var campagna='', rcampagna={};
      // var linea='', rlinea={};

      var levelKey=[], levelRecord=[];
      var levelField= [ 'ZIPCODE','CITY','COUNTY','codice_nome','FCP_COPYCMSCAMPAIGNID', 'linea'];
      // var levelField= [ 'custaccount','FCP_COPYCMSCAMPAIGNID', 'linea'];

      this.records.forEach(function(r, index) {

        r.Quantita_Totale=r.Quantita_Venduta+r.Quantita_Omaggio-r.Quantita_Rese;

        levelField.forEach(function(f,i) {
          if (levelKey[i]!=r[f]) {
            var nr={ nRecord:0, sommaSconto:0, Importo:0, isbold:i<=4, Id:r.custaccount, Quantita_Venduta:0, Quantita_Omaggio:0, Quantita_Rese:0,  Quantita_Totale:0, Sconto:0 };
            nr[f]=r[f];
            levelRecord[i]=nr;    
            for (var j=i;j>=0;j--)        
              nr[ levelField[j] ]=r[ levelField[j] ];

            this.rows.push(levelRecord[i]);
            levelKey[i]=r[f];
            // reset sottolivelli
            for (var j=i+1;j<levelKey.length;j++)        
              levelKey[j]='';
          }
          levelRecord[i].nRecord+=1;
          levelRecord[i].Importo+=r.Importo;
          levelRecord[i].Quantita_Venduta+=r.Quantita_Venduta;
          levelRecord[i].Quantita_Omaggio+=r.Quantita_Omaggio;
          levelRecord[i].Quantita_Rese+=r.Quantita_Rese;
          levelRecord[i].Quantita_Totale=levelRecord[i].Quantita_Venduta+levelRecord[i].Quantita_Omaggio-levelRecord[i].Quantita_Rese;

          if (r.Quantita_Totale) {
            levelRecord[i].sommaSconto+=r.Sconto/100*r.Importo;
            if (levelRecord[i].Quantita_Totale!=0)
              levelRecord[i].Sconto=levelRecord[i].sommaSconto/levelRecord[i].Importo*100;
          }
        },this);
/*
          if (campagna!=r.FCP_COPYCMSCAMPAIGNID) {
            rcampagna={FCP_COPYCMSCAMPAIGNID:r.FCP_COPYCMSCAMPAIGNID, Importo:0, isbold:false, id:index+'/campaign' };
            this.rows.push(rcampagna);
            campagna=r.FCP_COPYCMSCAMPAIGNID;
          }
          if (linea!=r.linea) {
//            var desclinea=this.linee.find(function(v) { return v.Name==r.FCP_ITEMPRODUCTLINEID__c; });
            var descrizione=''; // (desclinea?desclinea.Descrizione__c:'');
            rlinea={itemid:r.linea, descrizione_articolo:descrizione, Importo:0, isbold:true, id:index+'/line'};
            this.rows.push(rlinea);
            linea=r.linea;
          }
        rcampagna.Importo+=r.Importo;
        rlinea.Importo+=r.Importo;
*/
       r.FCP_COPYCMSCAMPAIGNID='';
        r.Id=r.custaccount;
        this.rows.push(r);
      }, this)

      if (this.filteredRow>=0) {
        console.log('trim rows:'+this.filteredRow)
        this.rows.splice(this.filteredRow+1, this.rows.length)
        this.rows.splice(0, this.filteredRow)
      }

      console.log('fine getcol');
      console.log(new Date());

    },
    getRecords: function() {
      console.log('campagna')
      console.log(this.campagna)
      var anno_cc=this.campagna.substr(0,4);
      var cc=this.campagna.substr(5,2);

      console.log(anno_cc)
      console.log(cc)

      var self=this;
      var sql='';

      // es: "2021 SC"
      var filtrocampagne=[];
      this.campagne.forEach(function(f,i) {
        if (f) {
          var wc=this.$store.state.campagne[i];
          var w="( righe.FCP_COPYCMSYEAR="+wc.substr(0,4)+" and righe.FCP_COPYCMSCAMPAIGNID='"+wc.substr(5,2)+"' )";
          filtrocampagne.push(w);
        }
      }, this);
      var wcampagne=filtrocampagne.join(' OR ');
      if (wcampagne>'') wcampagne='( '+wcampagne+' ) AND ';

sql="select clienti.COUNTY, clienti.CITY, clienti.ZIPCODE, ";
sql+="righe.FCP_COPYCMSYEAR, righe.FCP_COPYCMSCAMPAIGNID, fatture.ORDERACCOUNT as custaccount, clienti.NAME as nome_cliente, concat(fatture.ORDERACCOUNT, ' - ',clienti.NAME) as codice_nome, prodotti.FCP_ITEMPRODUCTLINEID as linea,";
sql+="righe.itemid, righe.name as descrizione_articolo, sum(righe.QTY) Quantita, ";
sql+="sum( case when GOODSFORFREE=0 and righe.QTY>=0 then righe.QTy else 0 end ) as Quantita_Venduta, ";
sql+="sum( case GOODSFORFREE when 0 then 0 when 1 then righe.QTy end ) as Quantita_Omaggio,";
sql+="sum( case when righe.QTY>=0 then 0 when righe.QTY<0 then SAFE_NEGATE(righe.QTy) end ) as Quantita_Rese,";
sql+="sum(LINEAMOUNTMST) as Importo, avg(DISCPERCENT) as Sconto ";
sql+="from ax.CUSTINVOICETRANS righe ";
sql+="left join ax.CUSTINVOICEJOUR fatture on (righe.INVOICEID=fatture.INVOICEID) ";
sql+="left join ax.CUSTTABLE clienti on (fatture.ORDERACCOUNT=clienti.ACCOUNTNUM) ";
sql+="left join ax.INVENTTABLE as prodotti on (righe.itemid=prodotti.itemid) ";
sql+="where "+wcampagne;
//sql+="where righe.FCP_COPYCMSYEAR=2020 and righe.FCP_COPYCMSCAMPAIGNID in ('SC','PW','MO') ";
// sql+=" and clienti.ACCOUNTNUM='C1018655' ";
sql+=" righe.zona1 like '"+this.$store.getters.zona+"' ";
sql+="group by clienti.ZIPCODE, clienti.CITY, clienti.COUNTY, righe.FCP_COPYCMSYEAR,  fatture.ORDERACCOUNT, clienti.NAME, righe.FCP_COPYCMSCAMPAIGNID, prodotti.FCP_ITEMPRODUCTLINEID, righe.itemid, righe.name ";
sql+="order by clienti.ZIPCODE, clienti.CITY, clienti.COUNTY, righe.FCP_COPYCMSYEAR,  fatture.ORDERACCOUNT, clienti.NAME, righe.FCP_COPYCMSCAMPAIGNID,prodotti.FCP_ITEMPRODUCTLINEID, righe.itemid, righe.name ";
// sql+=' limit 500';

      console.log(sql);
      console.log(new Date());

      this.busy=true;

      apiclient.getBQ(this.$store.getters.connection, sql)
        .then(function(records) {
          self.records=records;
          console.log(records.length);
          console.log(new Date());
          self.getCols();
          self.busy=false;

      console.log('fine callback');
      console.log(new Date());

        });
    },    

  }
}
</script>

<style scoped>

testata {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}

</style>
